module.exports = __webpack_public_path__ + "public/img/logo-horizontal-dark.ecbb39d5.svg";